(() => {
  if (customElements.get("media-with-text-expand")) return;

  class MediaWithTextExpand extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector("[data-expand-toggle]");
      this.wrap = this.querySelector(".media-with-text__text-wrap");
      this.content = this.querySelector(".media-with-text__text");
      this.labelMore = this.querySelector("[data-label-more]");
      this.labelLess = this.querySelector("[data-label-less]");

      if (!this.toggle || !this.wrap || !this.content) return;

      this.onClick = () => this.setOpen(this.toggle.getAttribute("aria-expanded") !== "true");
      this.toggle.addEventListener("click", this.onClick);

      this.onResize = () => {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.updateCollapsible(), 100);
      };
      window.addEventListener("resize", this.onResize);

      // Wait a frame so fonts/layout settle before measuring.
      requestAnimationFrame(() => this.updateCollapsible());
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener("click", this.onClick);
      window.removeEventListener("resize", this.onResize);
      window.clearTimeout(this.resizeTimer);
    }

    updateCollapsible() {
      const wasExpanded = this.classList.contains("is-expanded");

      // Apply collapsed clamp temporarily so we can compare heights.
      this.classList.add("is-collapsible");
      this.classList.remove("is-expanded");

      const clampHeight = this.wrap.clientHeight;
      const contentHeight = this.content.scrollHeight;
      const needsCollapse = contentHeight > clampHeight + 1;

      this.classList.toggle("is-collapsible", needsCollapse);
      this.toggle.hidden = !needsCollapse;

      if (!needsCollapse) {
        this.setOpen(false);
        return;
      }

      this.setOpen(wasExpanded);
    }

    setOpen(open) {
      this.toggle.setAttribute("aria-expanded", open ? "true" : "false");
      this.classList.toggle("is-expanded", open);

      if (this.labelMore) this.labelMore.hidden = open;
      if (this.labelLess) this.labelLess.hidden = !open;
    }
  }

  customElements.define("media-with-text-expand", MediaWithTextExpand);
})();
